<template>
  <div>
    <div class="row"
         style="justify-content: flex-end;align-items: center;margin-top:-32px;margin-bottom:30px">
      <el-input placeholder="请输入标题"
                v-model="keyword"
                size="small"
                style="width:300px"
                clearable>
        <el-button slot="append"
                   @click="getList"
                   icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div class="listbox">
      <table>
        <thead>
          <tr>
            <th>课程标题</th>
            <th style="width:120px">课程封面图</th>
            <th style="width:80px">类型</th>
            <th style="width:180px">创建时间</th>
            <th style="width:90px">是否上架</th>
            <!-- <th style="width:90px">进度条<i class="el-icon-info"
                 v-popover:popover></i>
            </th> -->
            <th style="width:100px">排序<i class="el-icon-info"
                 v-popover:popover2></i>
            </th>
            <th style="width:90px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in storeList"
              :key="index">
            <td>{{item.title}}</td>
            <td>
              <img :src="item.coverpicture"
                   class="tbImage"
                   v-show="item.coverpicture"
                   alt="">
            </td>
            <td>{{item.resType==2?'视频':(item.resType==3?'音频':'PDF')}}</td>
            <td>{{item.createDate}}</td>
            <td>
              <el-switch v-model="item.is_Putaway"
                         @change="changePutaway(item.is_Putaway,item.id)"
                         active-color="#0b8586">
              </el-switch>
            </td>
            <!-- <td>
              <el-switch v-model="item.isFastForward"
                         active-color="#0b8586">
              </el-switch>
            </td> -->
            <td>
              <span v-show="updateSortId!=item.id"
                    style="cursor: pointer;color:#0B8586;"
                    @click="updateSortId=item.id;updateSort=item.sort">{{item.sort}}</span>
              <input v-if="updateSortId==item.id"
                     @blur="changeSort(item.id)"
                     style="width:60px"
                     v-model="updateSort"
                     v-myfocus
                     type="text">
            </td>
            <td>
              <a @click="toCourse(item.id)"
                 style="color:#0b8586;margin-right:8px;font-size:12px;"
                 href="javascript:0">查看</a>
              <el-popconfirm :title="'您确定要删除此课程吗？'"
                             @confirm="toDeleteResources(item.id)">
                <a slot="reference"
                   style="color:#0b8586;font-size:12px;"
                   href="javascript:0">删除</a>
              </el-popconfirm>
            </td>
          </tr>
          <tr v-show="storeList.length<1">
            <td colspan="7">
              <span>暂无课程信息</span>
              <!-- <a style="color:#0b8586"
                 @click="toAddCourse"
                 href="javascript:0">上传课程</a> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination :total="pageCount"
                v-show="storeList.length>0"
                :limit="pageSize"
                :page="pageIndex"
                @page-change="pageChange"></pagination>
    <el-popover ref="popover"
                placement="bottom"
                title="注意"
                width="200"
                trigger="hover"
                content="此项控制视频播放是否可以快进">
    </el-popover>
    <el-popover ref="popover2"
                placement="bottom"
                title="排序"
                width="130"
                trigger="hover"
                content="数值越大排列越靠前">
    </el-popover>
    <perview :prerurl="prerurl"
             :show="IsPreview"
             :width="'856px'"
             title="课程预览"
             @dialogData="closeDialog"></perview>
  </div>
</template>
<script>
import pagination from '../../views/components/page/paginationset';
import Perview from '../Preview/Preview-template.vue';
export default {
  components: {
    pagination,
    Perview
  },
  props: {
  },
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      storeList: [],
      orgid: 0,
      keyword: '',
      updateSortId: 0,
      updateSort: '',
      prerurl: '',
      IsPreview: false
    };
  },
  created () {
    this.orgid = Number(localStorage.getItem('storeId'))
    this.getList()
  },
  methods: {
    getList () {
      this.pageIndex = 1
      this.GetMyStoreList()
    },
    GetMyStoreList () {
      this.httphelper.post('/api/EnterpriseApi/GetGpIntCoursePageList', {
        type: 0,
        orgid: this.orgid,
        title: this.keyword,
        page: this.pageIndex,
        limit: this.pageSize
      })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data
            this.pageCount = res.data.totalcount
          }
        });
    },
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList()
    },
    changeSort (id) {
      this.httphelper.post('/api/EnterpriseApi/UpdIntCourseSort', {
        id: id,
        sort: Number(this.updateSort)
      })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.updateSortId = 0;
            this.$message.success('更改排序成功');
          }
        });
    },
    changePutaway (status, id) {
      this.httphelper.post('/api/EnterpriseApi/UpdIntCourseShow', {
        id: id,
        status: status
      })
        .then(res => {
          if (res.data.code == 200) {
            if (status == true) this.$message.success('上架成功');
            if (status == false) this.$message.success('下架成功');
          }
        });
    },
    toDeleteResources (id) {
      this.httphelper.post('/api/EnterpriseApi/DelIntCourse', {
        id: id
      })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        });
    },
    toCourse (id) {
      this.httphelper.get('/api/EnterpriseApi/GetIntCourseResUlr', {
        id: id
      })
        .then(res => {
          if (res.code == 200) {
            this.prerurl = res.data
            this.IsPreview = true
          }
        });
      //   let { href } = this.$router.resolve({
      //     path: '/course',
      //     query: {
      //       cid: id,
      //       orgid: this.orgid
      //     }
      //   });
      //   window.open(href, '_blank');
    },
    // toAddCourse () {
    //   this.$emit('changeTabIndex', 1)
    // }
    closeDialog () {
      this.IsPreview = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.row {
    display: flex;
    margin-bottom: 20px;
}
.listbox {
    width: 100%;
    margin-top: 20px;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
    i {
        margin-left: 2px;
    }
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.tbImage {
    width: 65px;
    height: 45px;
}
</style>